import { NEUE_AUFGABE, useDialogLink, type NeueAufgabeVorgabe } from "../dialog";
import { KnopfLink } from "./Knopf";

/** „Neue Aufgabe“ oben rechts auf jeder Seite. Öffnet denselben Dialog über der aktuellen Seite, wie das Plus in der unteren Leiste. */
export function NeueAufgabeKnopf({ vorgabe }: { vorgabe?: NeueAufgabeVorgabe }) {
  const link = useDialogLink(NEUE_AUFGABE, vorgabe);
  return (
    <KnopfLink to={link.to} state={link.state} art="primaer">
      Neue Aufgabe
    </KnopfLink>
  );
}
